module.exports = __webpack_public_path__ + "img/level.2622e59d.png";